export const enClientPortalValuationComparables = {
    emptyStateTitle: 'No data available for this section.',
    marketAreaDefinitions: {
        rentableArea: 'Price per m² rentable area',
        grossFloorArea: 'Price per m² GFA',
        landArea: 'Price per m² land area',
    },
    marketAreaReferenceUnits: {
        rentableArea: '€/m² rentable area',
        grossFloorArea: '€/m² GFA',
        landArea: '€/m² land area',
    },
    autoConvertedFootNote: 'Automatically calculated from {{footNote}}',
}
